import { useMemo } from 'preact/hooks'
import { useAthosContext } from '../fetchers/provider'

export function insertInlineMerch(results) {
  if (!results?.results) return []
  const items = [...results.results]

  const pageStart = (results.pagination?.begin ?? 1) - 1
  const pageEnd = (results.pagination?.end ?? items.length) - 1

  const inline = [...(results?.merchandising?.content?.inline || [])].sort(
    (a, b) => a.config.position.index - b.config.position.index
  )

  inline.forEach((content) => {
    const position = content.config.position.index
    if (position < pageStart || position > pageEnd) return
    items.splice(position - pageStart, 0, content)
  })

  items.forEach((item) => (item.page = results?.pagination?.currentPage))

  return items
}

export function useMerchedResults() {
  const { results } = useAthosContext()

  return useMemo(() => insertInlineMerch(results), [results])
}
